"use strict";
/* globals module */
/**
 * @module userSkillRoute
 * @description Baasic User Skill Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Skill Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var UserSkillRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserSkillRoute, _super);
    function UserSkillRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'profiles/{userId}/skills/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{userId}/skills/{id}/{?embed,fields}';
        _this.createRoute = 'profiles/{userId}/skills';
        _this.updateRoute = 'profiles/{userId}/skills/{id}';
        _this.deleteRoute = 'profiles/{userId}/skills/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user skill properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user skill subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user skill property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userSkillRoute.find({searchQuery: '<search-phrase>'});
     **/
    UserSkillRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User profile id or display name which uniquely identifies user profile whose skill resources need to be retrieved.
     * @param options Query resource options object.
     * @example userSkillRoute.get(id, options);
     **/
    UserSkillRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @param data An user skill object that needs to be inserted into the system.
     * @example userSkillRoute.create(data);
     **/
    UserSkillRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data An user skill object used to update specific user skill resource in the system.
     * @example userSkillRoute.update(data);
     **/
    UserSkillRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this URI template does not expose any additional options.
     * @method
     * @param data An user skill object used to delete specific user skill resource in the system.
     * @example userSkillRoute.delete(data);
     **/
    UserSkillRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    UserSkillRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserSkillRoute);
    return UserSkillRoute;
}(common_1.BaseRoute));
exports.UserSkillRoute = UserSkillRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 
